<template>
  <div class="tw-w-full tw-flex tw-flex-col tw-items-center">
    <h2 class="question-title-v2 tw-mb-8 tw-text-center">
      {{ question.question }}
    </h2>
    <div class="tw-flex tw-flex-wrap tw-justify-center tw-gap-6">
      <button
        v-for="opt in answerList"
        :key="String(opt.id)"
        type="button"
        class="tw-flex tw-h-32 tw-w-32 tw-items-center tw-justify-center tw-rounded-full tw-border tw-text-sm tw-transition-colors"
        :class="isSelected(opt)
          ? 'tw-border-lavender-purple tw-text-lavender-purple'
          : 'tw-border-silver-sand tw-text-dark'"
        :disabled="disabled"
        @click="$emit('choose', opt)"
      >
        {{ opt.name }}
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Circle sub-layout of the `single` follow-up: binary Yes / No choices.
 * Controlled — highlight is driven by `selectedId`; clicking emits `choose`.
 */
export default {
  name: 'FollowupV7SingleCircle',

  props: {
    question: {
      type: Object,
      required: true,
    },
    selectedId: {
      type: [String, Number, Boolean],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    answerList() {
      return this.question.answerlist || [];
    },
  },

  methods: {
    isSelected(opt) {
      return this.selectedId != null && String(this.selectedId) === String(opt.id);
    },
  },
};
</script>
